'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件状态
 * 
 * @export
 * @class PluginState
 */
var PluginState =

/**
 * 创建一个状态
 * 
 * @ignore
 * @param {string} state 
 * @memberof PluginState
 */

/**
 * 已经启动
 * 
 * @type {PluginState}
 * @static
 * @memberof PluginState
 */

/**
 * 正在启动
 * 
 * @type {PluginState}
 * @static
 * @memberof PluginState
 */

/**
 * 安装状态
 * 
 * @type {PluginState}
 * @static
 * @memberof PluginState
 */
function PluginState(state) {
  (0, _classCallCheck3.default)(this, PluginState);

  this.state = state;
  (0, _freeze2.default)(this);
}

/**
 * 枚举的集合
 * 
 * @type {PluginState[]}
 * @static
 * @memberof PluginState
 */

/**
 * 已经卸载
 * 
 * @type {PluginState}
 * @static
 * @memberof PluginState
 */

/**
 * 正在停止
 * 
 * @type {PluginState}
 * @static
 * @memberof PluginState
 */

/**
 * 已解析状态
 * 
 * @type {PluginState}
 * @static
 * @memberof PluginState
 */
;

PluginState.INSTALLED = new PluginState('installed');
PluginState.RESOLVED = new PluginState('resolved');
PluginState.STARTING = new PluginState('starting');
PluginState.STOPPING = new PluginState('stopping');
PluginState.ACTIVE = new PluginState('active');
PluginState.UNINSTALLED = new PluginState('uninstalled');

PluginState.values = function () {
  var enumValues = [];
  enumValues.push(PluginState.INSTALLED);
  enumValues.push(PluginState.RESOLVED);
  enumValues.push(PluginState.STARTING);
  enumValues.push(PluginState.STOPPING);
  enumValues.push(PluginState.ACTIVE);
  enumValues.push(PluginState.UNINSTALLED);
  return enumValues;
};

exports.default = PluginState;


(0, _freeze2.default)(PluginState);
//# sourceMappingURL=PluginState.js.map